// import React, { useRef, useEffect } from 'react';
// import Cimg from './2.jpg';

// const useDraggable = () => {
//     const elementRef = useRef(null);
//     const isDragging = useRef(false);
//     const offset = useRef({ x: 0, y: 0 });

//     const handleMouseDown = (e) => {
//         isDragging.current = true;
//         const rect = elementRef.current.getBoundingClientRect();
//         offset.current = {
//             x: e.clientX - rect.left,
//             y: e.clientY - rect.top,
//         };
//     };

//     const handleMouseMove = (e) => {
//         if (isDragging.current) {
//             const x = e.clientX - offset.current.x;
//             const y = e.clientY - offset.current.y;

//             elementRef.current.style.transform = `translate(${x}px, ${y}px)`;
//         }
//     };

//     const handleMouseUp = () => {
//         isDragging.current = false;
//     };

//     useEffect(() => {
//         document.addEventListener('mousemove', handleMouseMove);
//         document.addEventListener('mouseup', handleMouseUp);

//         return () => {
//             document.removeEventListener('mousemove', handleMouseMove);
//             document.removeEventListener('mouseup', handleMouseUp);
//         };
//     }, []);

//     return {
//         ref: elementRef,
//         onMouseDown: handleMouseDown,
//     };
// };

// const DraggableImage = () => {
//     const { ref, onMouseDown } = useDraggable();

//     return (
//         <div
//             id="container"
//             style={{
//                 position: 'relative',
//                 width: '400px',
//                 height: '400px',
//                 overflow: 'hidden',
//                 border: '2px solid #ccc',
//                 cursor: 'grab',
//             }}
//             onMouseDown={onMouseDown}
//         >
//             <img
//                 id="draggableImage"
//                 ref={ref}
//                 src={Cimg}
//                 alt="Draggable Image"
//                 style={{
//                     position: 'absolute',
//                     userDrag: 'none',
//                     userSelect: 'none',
//                     transition: 'transform 0.2s ease',
//                 }}
//             />
//         </div>
//     );
// };

// export default DraggableImage;



// import React, { useRef, useEffect } from 'react';
// import Cimg from './2.jpg';

// const useDraggable = () => {
//     const elementRef = useRef(null);
//     const isDragging = useRef(false);
//     const offset = useRef({ x: 0, y: 0 });

//     const handleMouseDown = (e) => {
//         isDragging.current = true;
//         const rect = elementRef.current.getBoundingClientRect();
//         offset.current = {
//             x: e.clientX - rect.left,
//             y: e.clientY - rect.top,
//         };
//     };

//     const handleMouseMove = (e) => {
//         if (isDragging.current) {
//             const x = e.clientX - offset.current.x;
//             const y = e.clientY - offset.current.y;

//             elementRef.current.style.transform = `translate(${x}px, ${y}px)`;
//         }
//     };

//     const handleMouseUp = () => {
//         isDragging.current = false;
//     };

//     useEffect(() => {
//         document.addEventListener('mousemove', handleMouseMove);
//         document.addEventListener('mouseup', handleMouseUp);

//         return () => {
//             document.removeEventListener('mousemove', handleMouseMove);
//             document.removeEventListener('mouseup', handleMouseUp);
//         };
//     }, []);

//     return {
//         ref: elementRef,
//         onMouseDown: handleMouseDown,
//     };
// };

// const DraggableImage = () => {
//     const { ref, onMouseDown } = useDraggable();

//     return (
//         <div
//             id="container"
//             style={{
//                 position: 'relative',
//                 width: '400px',
//                 height: '400px',
//                 overflow: 'hidden',
//                 border: '2px solid #ccc',
//                 cursor: 'grab',
//             }}
//             onMouseDown={onMouseDown}
//         >
//             <img
//                 id="draggableImage"
//                 ref={ref}
//                 src={Cimg}
//                 alt="Draggable Image"
//                 style={{
//                     position: 'absolute',
//                     userDrag: 'none',
//                     userSelect: 'none',
//                     transition: 'transform 0.2s ease',
//                 }}
//             />
//         </div>
//     );
// };

// export default DraggableImage;





import React, { useRef, useEffect } from 'react';
import Cimg from './2.jpg';
import html2canvas from 'html2canvas';

const useDraggable = () => {
    const elementRef = useRef(null);
    const isDragging = useRef(false);
    const offset = useRef({ x: 0, y: 0 });

    const handleMouseDown = (e) => {
        isDragging.current = true;
        const rect = elementRef.current.getBoundingClientRect();
        offset.current = {
            x: e.clientX,
            y: e.clientY,
        };
    };

    // const handleMouseDown = (e) => {
    //     isDragging.current = true;
    //     const rect = elementRef.current.getBoundingClientRect();
    //     offset.current = {
    //         x: e.clientX - rect.left,
    //         y: e.clientY - rect.top,
    //     };
    // };

    const handleMouseMove = (e) => {
        if (isDragging.current) {
            requestAnimationFrame(() => {
                const x = e.clientX - offset.current.x;
                const y = e.clientY - offset.current.y;

                elementRef.current.style.transform = `translate3d(${x}px, ${y}px, 0)`;
            });
        }
    };

    const handleMouseUp = () => {
        isDragging.current = false;
    };

    useEffect(() => {
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    return {
        ref: elementRef,
        onMouseDown: handleMouseDown,
    };
};

const DraggableImage = () => {
    const { ref, onMouseDown } = useDraggable();
    const mathRef = useRef();

    const takeScreenshot = () => {
        const targetElement = document.getElementById('dp-container');
        html2canvas(targetElement).then(canvas => {
            // Create a new image element
            const img = new Image();
            img.src = canvas.toDataURL();

            // Append the image to the body or a specific element
            // document.body.appendChild(img);

            // Optionally, you can download the screenshot
            const link = document.createElement('a');
            link.href = canvas.toDataURL('image/png');
            link.download = 'screenshot.png';
            link.click();
        });
    };

    return (
        <>
            <div
                id="dp-container"
                style={{
                    position: 'relative',
                    width: '400px',
                    height: '400px',
                    overflow: 'hidden',
                    border: '2px solid #ccc',
                    cursor: 'grab',
                }}
                onMouseDown={onMouseDown}
            >
                <img
                    id="draggableImage"
                    ref={ref}
                    src={Cimg}
                    alt="Draggable Image"
                    style={{
                        position: 'absolute',
                        userDrag: 'none',
                        userSelect: 'none',
                        transition: 'transform 0.2s ease',
                        willChange: 'transform',
                    }}
                />
            </div>
            <button onClick={takeScreenshot}>Take Screenshot</button>
        </>
    );
};


export default DraggableImage;
